import { MULTI_CART_DATA } from '@spartacus/cart/base/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { StateUtils } from '@spartacus/core';
import { GenNotification } from 'src/app/generac/models/notification.model';

export const GEN_CART_ADD_ENTRY = '[Cart-entry] Add Entry';
export const GEN_CART_ADD_ENTRY_SUCCESS = '[Cart-entry] Add Entry Success';
export const GEN_CART_ADD_ENTRY_FAIL = '[Cart-entry] Add Entry Fail';
export const GEN_CART_REMOVE_ENTRY = '[Cart-entry] Remove Entry';
export const GEN_CART_REMOVE_ENTRY_SUCCESS = '[Cart-entry] Remove Entry Success';
export const GEN_CART_REMOVE_ENTRY_FAIL = '[Cart-entry] Remove Entry Fail';

export const GEN_CART_UPDATE_ENTRY = '[Cart-entry] Update Entry';
export const GEN_CART_UPDATE_ENTRY_SUCCESS = '[Cart-entry] Update Entry Success';
export const GEN_CART_UPDATE_ENTRY_FAIL = '[Cart-entry] Update Entry Fail';

export class GenCartAddEntry extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = GEN_CART_ADD_ENTRY;
  constructor(
    public payload: {
      cartId: string;
      userId: string;
      productCode: string;
      quantity: number;
      itemListName: string,
      navigatedToPdpFrom: string,
      entrySource?: string,
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartAddEntrySuccess extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_ADD_ENTRY_SUCCESS;
  constructor(
    public payload: {
      userId: string;
      cartId: string;
      productCode: string;
      quantity: number;
      deliveryModeChanged?: boolean;
      entry?: OrderEntry;
      quantityAdded?: number;
      statusCode?: string;
      statusMessage?: string;
      availableInventory?: number;
      generacNotifications?: GenNotification[];
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartAddEntryFail extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_ADD_ENTRY_FAIL;
  constructor(
    public payload: {
      userId: string;
      cartId: string;
      productCode: string;
      quantity: number;
      error: any;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartRemoveEntry extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = GEN_CART_REMOVE_ENTRY;
  constructor(
    public payload: { cartId: string; userId: string; entryNumber: string }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartRemoveEntrySuccess extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_REMOVE_ENTRY_SUCCESS;
  constructor(
    public payload: { userId: string; cartId: string; entryNumber: string }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartRemoveEntryFail extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_REMOVE_ENTRY_FAIL;
  constructor(
    public payload: {
      error: any;
      cartId: string;
      userId: string;
      entryNumber: string;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartUpdateEntry extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = GEN_CART_UPDATE_ENTRY;
  constructor(
    public payload: {
      userId: string;
      cartId: string;
      entryNumber: string;
      quantity: number;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartUpdateEntrySuccess extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_UPDATE_ENTRY_SUCCESS;
  constructor(
    public payload: {
      userId: string;
      cartId: string;
      entryNumber: string;
      quantity?: number;
      statusCode?: string;
      availableInventory?: number;
      generacNotifications?: GenNotification[];
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export class GenCartUpdateEntryFail extends StateUtils.EntityProcessesDecrementAction {
  override readonly type = GEN_CART_UPDATE_ENTRY_FAIL;
  constructor(
    public payload: {
      error: any;
      userId: string;
      cartId: string;
      entryNumber: string;
      quantity?: number;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}

export type CartEntryAction =
  | GenCartAddEntry
  | GenCartAddEntrySuccess
  | GenCartAddEntryFail
  | GenCartRemoveEntry
  | GenCartRemoveEntrySuccess
  | GenCartRemoveEntryFail
  | GenCartUpdateEntry
  | GenCartUpdateEntrySuccess
  | GenCartUpdateEntryFail;
